import { render, staticRenderFns } from "./Tvbrtv.vue?vue&type=template&id=6b379845&scoped=true&"
import script from "./Tvbrtv.vue?vue&type=script&lang=js&"
export * from "./Tvbrtv.vue?vue&type=script&lang=js&"
import style0 from "./Tvbrtv.vue?vue&type=style&index=0&id=6b379845&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b379845",
  null
  
)

export default component.exports